module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/_fails.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/_fails.js
// module chunks = 0